<template>
  <div class="award-card">
    <p class="year">{{ awardYear }}</p>
    <p class="name">
      <strong>{{ awardName }}</strong>
    </p>
    <p class="reporter">{{ awardReporter }}</p>
  </div>
</template>

<script>
export default {
  name: 'AwardCard',
  props: {
    awardName: { required: true, type: String },
    awardReporter: { required: true, type: String },
    awardYear: { required: true, type: Number },
  },
};
</script>

<style scoped lang="scss">
.award-card {
  border-bottom: 1px solid rgb(218, 226, 234);
  border-spacing: 20px 20px;
}
.name,
.year {
  color: rgb(25, 34, 43);
  margin-bottom: 0.5em;
}
.name,
.reporter {
  margin-top: 0;
}
.year {
  margin-top: 1.5em;
}
.reporter {
  color: rgb(109, 119, 131);
  margin-bottom: 1em;
}
</style>
